import script from "./PositionHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionHistory.vue?vue&type=script&setup=true&lang=js"

import "./PositionHistory.vue?vue&type=style&index=0&id=75487368&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75487368"]])

export default __exports__